import { ListService } from '@abp/ng.core';
import { eSaasComponents, SaasEntityActionContributors } from '@volo/abp.ng.saas';
import { EntityAction, EntityActionList } from '@abp/ng.components/extensible';
import { TenantCustomActionsService } from './tenant-custom-actions.service';
import { SaasTenantDto } from '@volo/abp.ng.saas/proxy';

export function cloneTenantActionContributor(actionList: EntityActionList<SaasTenantDto>) {
  const cloneAction = new EntityAction<SaasTenantDto>({
    text: 'SaasService::CloneTenant',
    action: data => {
      const service = data.getInjected(TenantCustomActionsService);
      service.cloneTenant(data.record, data.getInjected(ListService));
    },
    permission: 'Saas.Tenants.Create',
    visible: data => !!data.record.extraProperties.IsTemplate,
  });

  actionList.addHead(cloneAction);
}

export const saasEntityActionContributors: SaasEntityActionContributors = {
  [eSaasComponents.Tenants]: [cloneTenantActionContributor],
};
